/**
 * 扣费信息路由
 */
const CostRouter = {
  path: 'cost',
  name: 'Cost',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Cost/index')
}
export default CostRouter
